import styled, { css } from 'styled-components';

import UI from '#front-credpago';

import { ReactComponent as Note1 } from '../../images/note-1.svg';
import { ReactComponent as Note2 } from '../../images/note-2.svg';
import { ReactComponent as Note3 } from '../../images/note-3.svg';
import { ReactComponent as Note4 } from '../../images/note-4.svg';
import { ReactComponent as Note5 } from '../../images/note-5.svg';
import { ReactComponent as Note6 } from '../../images/note-6.svg';
import { ReactComponent as Note7 } from '../../images/note-7.svg';
import { ReactComponent as Note8 } from '../../images/note-8.svg';
import { ReactComponent as Note9 } from '../../images/note-9.svg';
import { ReactComponent as Note10 } from '../../images/note-10.svg';
import globals from '../globals';

export const Container = styled.div`
  width: 100%;
  max-width: calc(${globals.containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Wrapper = styled.div`
  margin: 100px 0px;
  padding: 20px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm}, ${UI.globals.mediaqueries.md} {
    margin: 25px 0px 50px 0px;
  }
`;

export const WrapperQuestion = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const Question = styled.h3`
  font-size: 24px;
  color: ${globals.colors.darkBlue};
  font-family: ${globals.fonts.default};
  font-weight: 600;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm}, ${UI.globals.mediaqueries.md} {
    text-align: center;
  }
`;

export const WrapperNote = styled.div`
  display: flex;
  cursor: pointer;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    flex-wrap: wrap;
    justify-content: center;
  }
`;

export const WrapperQuestionOne = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 10px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin: 5px;
  }
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin-top: 30px;
    justify-content: space-between;
  }
`;

const wrapperImgModifiers = {
  selected: () => css`
    circle:not(.st1) {
      fill: #b1b1b1;
    }
  `,
};

export const WrapperImg = styled.div`
  ${({ selected }) => css`
    width: 50px;
    height: 50px;

    ${!selected && wrapperImgModifiers.selected()}
  `}
`;

export const WrapperRadios = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 500px;
  text-align: center;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    width: 320px;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media ${UI.globals.mediaqueries.md} {
    width: 720px !important;
  }
`;

export const WrapperInput = styled.div`
  width: 700px;
  margin-top: 30px;
  text-align: center;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const WrapperTextArea = styled.div`
  width: 70%;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    margin-bottom: 20px;
    width: 100%;
  }
`;

export const WrapperBtn = styled.div`
  width: 140px;
`;

export const WrapperConfirmation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const AlertWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  justify-content: center;
`;

export const Error = styled.span`
  color: ${globals.colors.danger};
  font-family: ${globals.fonts.default};
  font-size: 16px;
  font-weight: bold;
`;

const applyImg = (img) => styled(img)`
  width: 50px;
  height: 50px;
`;

export const ImgNote1 = applyImg(Note1);
export const ImgNote2 = applyImg(Note2);
export const ImgNote3 = applyImg(Note3);
export const ImgNote4 = applyImg(Note4);
export const ImgNote5 = applyImg(Note5);
export const ImgNote6 = applyImg(Note6);
export const ImgNote7 = applyImg(Note7);
export const ImgNote8 = applyImg(Note8);
export const ImgNote9 = applyImg(Note9);
export const ImgNote10 = applyImg(Note10);
